module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med tjenesteløfte_primærlogo_pos(svart).78c1e89c.svg";